import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { MessageService } from 'primeng/api';
import { bmxurl } from 'src/globals';
import { cTillproductoptions } from 'src/types/tillproductoptions';
import { users_returndata } from 'src/types/user_returndata';
import { GlobalService } from '../../_services/global.service';

@Component({
  selector: 'app-tillproductoptionsedit',
  templateUrl: './tillproductoptionsedit.component.html',
  styleUrls: ['./tillproductoptionsedit.component.css']
})
export class TillproductoptionseditComponent implements OnInit {
  VenueID: string = localStorage.getItem("SmartVenueID")!;
  httpResponse: any;
  id: string;
  pageReady: boolean = true;

  AccessAllowed: boolean = false;
  CompletedLoading: boolean = false;

  optionNameValid: boolean = true;

  CurrencySymbol: string = localStorage.getItem("Currency") == null ? "GBP" : localStorage.getItem("Currency")!;

  enabledOptions: any[] = [
    { label: 'Enabled', value: false },
    { label: 'Disabled', value: true }
  ];

  Option: cTillproductoptions = new cTillproductoptions({
    id: null,
    name: '',
    price: 0,
    disabled: false,
    venueid: this.VenueID,
    colour: '',
    qty: 0
  });

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private router: Router,
    private messageService: MessageService,
    private globalService: GlobalService
  ) {}

  ngOnInit(): void {
    this.globalService.setSmallScreenMenu(false);

    const userid = localStorage.getItem("SmartUserID");
    this.http.get(bmxurl + "User/" + userid).subscribe({
      next: (response: any) => {
        this.httpResponse = response as users_returndata;
        if (this.httpResponse.succeeded) {
          this.AccessAllowed = true;
          this.id = this.route.snapshot.paramMap.get('id');

          if (this.id !== "0") {
            this.pageReady = false;
            this.http.get(bmxurl + "TillProductOptions/" + this.VenueID + "/" + this.id).subscribe({
              next: (res: any) => {
                this.httpResponse = res;
                if (this.httpResponse.succeeded) {
                  const rawData = this.httpResponse.data;
                  const data = Array.isArray(rawData) ? rawData[0] : rawData;
                  if (data) {
                    this.Option = new cTillproductoptions(data);
                    this.pageReady = true;
                  } else {
                    this.messageService.add({ severity: 'warn', summary: 'Not Found', detail: 'Option could not be loaded' });
                    this.pageReady = true;
                  }
                } else {
                  this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error loading option: ' + (this.httpResponse.messages?.[0] ?? '') });
                  this.pageReady = false;
                }
              },
              error: () => {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error loading option' });
                this.pageReady = false;
              }
            });
          }
        }
        this.CompletedLoading = true;
      },
      error: () => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error while getting User' });
      }
    });
  }

  updateData(): void {
    if (!this.doValidCheck()) return;

    this.Option.venueid = this.VenueID;

    if (this.id === "0") {
      this.http.post(bmxurl + "TillProductOptions", this.Option).subscribe({
        next: (response: any) => {
          this.httpResponse = response;
          if (this.httpResponse.succeeded) {
            this.messageService.add({ severity: 'success', summary: 'Saved', detail: 'Option successfully created' });
            this.router.navigateByUrl("/tillproductoptions");
          } else {
            this.messageService.add({ severity: 'error', summary: 'Not Saved', detail: this.httpResponse.messages?.[0] ?? 'Save failed' });
          }
        },
        error: () => {
          this.messageService.add({ severity: 'error', summary: 'Not Saved', detail: 'Error saving option' });
        }
      });
    } else {
      this.http.put(bmxurl + "TillProductOptions", this.Option).subscribe({
        next: (response: any) => {
          this.httpResponse = response;
          if (this.httpResponse.succeeded) {
            this.messageService.add({ severity: 'success', summary: 'Saved', detail: 'Option successfully updated' });
            this.router.navigateByUrl("/tillproductoptions");
          } else {
            this.messageService.add({ severity: 'error', summary: 'Not Saved', detail: this.httpResponse.messages?.[0] ?? 'Save failed' });
          }
        },
        error: () => {
          this.messageService.add({ severity: 'error', summary: 'Not Saved', detail: 'Error saving option' });
        }
      });
    }
  }

  doValidCheck(): boolean {
    if (!this.Option.name?.trim()) {
      this.optionNameValid = false;
      return false;
    }
    this.optionNameValid = true;
    return true;
  }

  returnToList(): void {
    this.router.navigateByUrl("/tillproductoptions");
  }
}
